import React from "react";
import { Link } from "react-router-dom";
import { Trash2, Activity, FileText } from "react-feather";
import salesTotalsCalculator from "../helpers/salesTotalsCalculator";
import currencyFormat from "../helpers/currencyFormat";

const TourSummaryGigsRow = ({ token, tourId, gig, recipientNames, products, tourSales, userIsEditor }) => {

  const sales = tourSales.filter(sale => sale.gigId === gig._id);
  const gigDate = new Date(gig.date).toDateString();
  const financePath = "/tour/" + tourId + "/gig/" + gig._id + "/finance";
  const salesPath = "/tour/" + tourId + "/gig/" + gig._id + "/sales";
  const deletePath = "/delete/tour/" + tourId + "/gig/" + gig._id; 

  const totals = salesTotalsCalculator(sales, recipientNames);

  const iconSize = 20;

  return (
    <tr>
      <td>{gigDate}</td>
      <td>{gig.venue}</td>
      <td className="right">{currencyFormat(totals.totalRevenue / 100)}</td>
      <td className="right hideLtTablet">{currencyFormat(totals.paypalCommission / 100)}</td>
      <td className="right hideLtTablet">{currencyFormat(totals.netRevenue / 100)}</td>
      {
        recipientNames.length > 0 && recipientNames.map((recipientName, index) => {
          const recipient = totals.recipientShares
            .find(recipientShare => recipientShare.name === recipientName)
            || { name: "", share: 0 };
          return (
            <td className="right hideLtTablet" key={index}>{currencyFormat(recipient.share / 100)}</td>
          )
        })
      }
      <td className="right hideLtTablet">{currencyFormat(gig.venueCut / 100)}</td>
      {
        products.length > 0
        && 
        (
          <>
          <td><Link to={financePath} className="icon-button-link"><Activity size={iconSize} /></Link></td>
          <td><Link to={salesPath} className="icon-button-link"><FileText size={iconSize} /></Link></td>
          </>
        )
      }
      {
        userIsEditor &&
        (
          <td className="right"><Link to={deletePath} className="icon-button-link-warning"><Trash2 size={iconSize} /></Link></td>
        )
      }     
    </tr>      
  )
};

export default TourSummaryGigsRow;